import { BonusList } from "./BonusList"
import { BonusCreate } from "./BonusCreate"

export default {
  list: BonusList,
  create: BonusCreate,
}
